import AuthAPI from '../../api/auth'
import _ from 'lodash'

const initialState = () => ({
    isAuthenticated: false,
    accessToken: null,
    refreshToken: null,
    user: null,
    company: null,
    zepplinMasterToken: null
})

const getters = {
    getZepplinMasterToken(state) {
        return state.zepplinMasterToken
    }
}

const mutations = {
    SET_ZEPPLIN_MASTER_TOKEN(state, token) {
        state.zepplinMasterToken = token
    },
    SET_TOKENS(state,tokens){
        state.accessToken = tokens.accessToken
        state.refreshToken = tokens.refreshToken
    },
    AUTHENTICATE(state){
        state.isAuthenticated = true
    },
    SET_USER(state,user){
        state.user = user
    },
    SET_USER_AVATAR(state,userAvatarUrl){
        if(state.user){
            state.user.avatarUrl = userAvatarUrl
        }
    },
    SET_COMPANY(state, company) {
        state.company = company
    },
    LOGOUT(state){
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    }
}

const actions = {
    authenticate(context, {email, password}){
        return AuthAPI.token({email, password}).then((result) => {
            if(!result.data){
                return Promise.reject("Não foi possível adquirir o par de tokens do servidor")
            }
            const data = result.data
            context.commit("AUTHENTICATE")
            context.commit("SET_TOKENS", {
                accessToken: data.accessToken,
                refreshToken: data.refreshToken
            })
            context.dispatch('setUser', data.user)
            return result;
        })
    },
    authenticateByQRCode(context, { qrcodeKey }) {
        return AuthAPI.tokenByQRCode({ qrcodeKey })
            .then(res => {
                if(!res.data)
                    return Promise.reject('Não foi possível adquirir o par de tokens do servidor')

                const data = res.data
                context.commit("AUTHENTICATE")
                context.commit("SET_TOKENS", {
                    accessToken: data.accessToken,
                    refreshToken: data.refreshToken
                })
                context.dispatch('setUser', data.user)
                return res
            })
    },
    authenticateOffline(context, data) {
        context.commit("AUTHENTICATE")
        context.commit("SET_TOKENS", {
            accessToken: data.accessToken,
            refreshToken: data.refreshToken
        })
        context.dispatch('setUser', data.user)
    },
    refreshToken(context, {accessToken, refreshToken}){
        return context.commit("SET_TOKENS", {
            accessToken, refreshToken
        })
    },
    setUser(context,user){
        context.commit('SET_USER',user)
    },
    setUserAvatar(context,avatarUrl){
        context.commit('SET_USER_AVATAR',avatarUrl)
    },
    setCompany(context, company) {
        context.commit('SET_COMPANY', company)
    },
    logout(context){
        context.commit('LOGOUT')
    },
    setZepplinMasterToken(context, token) {
        context.commit('SET_ZEPPLIN_MASTER_TOKEN', token)
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    mutations,
    actions
}
